import React from 'react'

const Manual_forma_envio_geofence = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Configuración de forma de envío por Geofence
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Configura zonas de entrega automáticas basadas en ubicación geográfica (Geofence) dentro de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Configuracion_de_forma_de_envio_por_Geofence__Ivi2PZB0TEqvKSu0xf7olA?as=scrollable"
          className="scribe-iframe-general-105"
          width="100%"
          height="9200"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_forma_envio_geofence
